// Indirection over a raw dynamic import by URL — same reasoning as
// reload-page.util.ts: a literal `import()` call isn't mockable via
// jest.mock() the way a regular function import is, and Jest can't actually
// resolve an arbitrary http(s) URL as a module specifier the way a browser
// can, so callers that need unit tests mock this module instead.
export function importChunkUrl<T>(url: string): Promise<T> {
  // @vite-ignore: url is only known at runtime (extracted from a failed
  // import's own error message) — Vite/Rollup can't statically analyze it,
  // and don't need to: this re-fetches a chunk the build already produced,
  // it isn't importing new code (ENG-1830).
  return import(/* @vite-ignore */ url) as Promise<T>;
}
